import Store from '@nichoth/state';
import mxtend from 'xtend/mutable';

var TranscriptStore = Store.extend({
    _state: {
        data: null
    },

    clear: function () {
        this._state.data = null;
        return this.publish();
    },

    update: function (data) {
        mxtend(this._state.data, data);
        return this.publish();
    },

    getTranscriptInfo: function (data) {
        this._state.data = data;
        return this.publish();
    }
});

export default TranscriptStore;
